<div>
  <wl-profile-quicksearch
    #quickSearch
    [suppressAutoSearch]="true"
    (keywordChange)="quickSearch.search()"
    (searchComplete)="setResults($event)"
  ></wl-profile-quicksearch>
</div>
<div *ngIf="profileResults">
  <wl-profile-results-grid [selectButtonText]="selectButtonText" [profiles]="profileResults" (onProfileSelected)="profileSelected.emit($event)"></wl-profile-results-grid>
</div>
<div *ngIf="profileResults?.TotalCount == 0" class="mt-10">
  <span>{{ 'common.no-matching-profile' | translate }}</span>
</div>
